import {Box, Heading, Spinner, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {useAuth, UserStatus } from '../../../auth/AuthProvider';
import { Census } from '../../../model/census';
import {useApiProvider} from '../../../api/ApiProvider';
import { InstructorRole } from "../../../model/instructor";
import Migrate from "./Migrate";
import Register from "../protected/registration/Register";
import LoadingWidget from "../../parts/LoadingWidget";
import {CensusForLeaderDTO} from "../../../model/censusForLeaderDTO";
import LeaderCensusesSummary from "../../parts/LeaderCensusesSummary";
import SendCensusRender from "../../parts/CensusRenderComponent";
import CensusRenderComponent from "../../parts/CensusRenderComponent";

const Home: React.FC = () => {

    const provider = useApiProvider();
    const userAuth = useAuth();
    

    const [census, setCensus] = useState<Census>();
    const [leaderCensuses, setLeaderCensuses] = useState<CensusForLeaderDTO[]>([]);
    const [isFetched, setIsFetched] = useState<boolean>(false);
    const [areLeaderCensusesFetched, setAreLeaderCensusesFetched] = useState<boolean>(false);

    const getWelcome = (): string => {
        const currentHour: number = new Date().getHours();

        if (currentHour >= 3 && currentHour < 18) {
            return 'Dzień dobry';  // Between 03:00 and 18:00
        }
        else if (currentHour >= 18 && currentHour < 22) {
            return 'Dobry wieczór'; // Between 18:00 and 22:00
        }
        else {
            return 'Dobrej nocy';   // Between 22:00 and 03:00
        }
    }

    const getCensuses = () => {
        userAuth.user?.InstructorRole === InstructorRole.Leader ? getLeaderCensuses() : getInstructorCensus()
    }

    const getLeaderCensuses = async () => {
        provider.getLeaderCensuses()
            .then(censuses => setLeaderCensuses(censuses))
            .catch(err => console.error(err))
            .finally(() => setIsFetched(true))
            .finally(() => setAreLeaderCensusesFetched(true));
    }

    const getInstructorCensus = async () => {
        provider.getCensus()
            .then(census => setCensus(census))
            .catch(err => console.error(err))
            .finally(() => setIsFetched(true));
    }

    useEffect(() => {
        getCensuses();
    }, [userAuth.user]);

    if (userAuth.userStatus === UserStatus.ToMigrate) return <Migrate />
    if (userAuth.userStatus === UserStatus.ToRegister) return <Register />
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            width="100vw"
            mt="100px"
        >
            <Heading as="h2" size="xl">
                {getWelcome()}{userAuth.user?.Name ? ", " + userAuth.user?.Name : ""}!
            </Heading>
            {isFetched ? 
                (userAuth.user?.InstructorRole === InstructorRole.Leader ? 
                    (areLeaderCensusesFetched ? 
                            (leaderCensuses.length ? 
                                <LeaderCensusesSummary leaderCensuses={leaderCensuses} /> : 
                                <Text>Brak złożonych wniosków w twojej jednostce.</Text>) :
                            <LoadingWidget withImage={false}/>
                    ) : 
                    (census ? 
                        <CensusRenderComponent census={census} asTable={true} /> : 
                            <Text>Brak złożonych wniosków.</Text>)
            ) : <LoadingWidget withImage={false}/>}
        </Box>
    );

};

export default Home;